<template>
  <!-- Welcome Wrap -->
  <div class="card border-0">
    <div
      class="card-body d-flex align-items-center justify-content-between flex-wrap pb-1 dq-dashboard-hero"
    >
      <div class="d-flex align-items-center mb-3 dq-dashboard-hero-main">
        <span class="avatar avatar-xl flex-shrink-0">
          <img
            :src="welcomeAvatarUrl"
            class="rounded-circle"
            alt="img"
          />
        </span>
        <div class="ms-3">
          <h3 class="mb-2">Welcome Back, {{ userName }}!</h3>
          <p>
            You have
            <span class="text-primary text-decoration-underline">
              {{ pendingApprovalsCount }}
            </span>
            Pending Approvals
            <span class="d-inline d-sm-none"><br /></span>
            <span class="d-none d-sm-inline">&amp;</span>
            <span class="text-primary text-decoration-underline">
              {{ totalLeaveRequestsCount }}
            </span>
            Leave Requests
          </p>
        </div>
      </div>
      <!-- <div class="d-flex align-items-center flex-wrap mb-1">
        <a
          href="javascript:void(0);"
          class="btn btn-secondary btn-md me-2 mb-2"
          data-bs-toggle="modal"
          data-bs-target="#add_project"
        >
          <i class="ti ti-square-rounded-plus me-1"></i>
          Add Project
        </a>
        <a
          href="javascript:void(0);"
          class="btn btn-primary btn-md mb-2"
          data-bs-toggle="modal"
          data-bs-target="#add_leaves"
        >
          <i class="ti ti-square-rounded-plus me-1"></i>
          Add Requests
        </a>
      </div> -->
    </div>
  </div>
  <!-- /Welcome Wrap -->

  <div class="row">
    <!-- Widget Info -->
    <div class="col-xxl-12 d-flex">
      <div class="row flex-fill">
        <!-- Attendance Overview -->
        <div v-if="showAttendanceWidget" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-primary mb-2">
                <i class="ti ti-calendar-share fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">
                Attendance Overview ({{ props.year }})
              </h6>
              <h3 class="mb-3">
                {{ attendanceLabel }}
                <span class="fs-12 fw-medium text-success">
                  {{ attendancePresentPct }}% present
                </span>
              </h3>
              <router-link
                to="/attendance/attendance-employee"
                class="link-default"
              >
                View Details
              </router-link>
            </div>
          </div>
        </div>

        <!-- Total Projects -->
        <div v-if="showProjectsWidget" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-secondary mb-2">
                <i class="ti ti-browser fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">
                Total No of Project's ({{ props.year }})
              </h6>
              <h3 class="mb-3">
                {{ activeProjects }}/{{ totalProjects }}
                <!-- <span class="fs-12 fw-medium text-danger">
                  <i class="fa-solid fa-caret-down me-1"></i>
                  -2.1%
                </span> -->
              </h3>
              <router-link to="/projects/projects-list" class="link-default">
                View All
              </router-link>
            </div>
          </div>
        </div>

        <!-- Total Clients -->
        <div v-if="showClientsWidget" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-info mb-2">
                <i class="ti ti-users-group fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">
                Total No of Clients ({{ props.year }})
              </h6>
              <h3 class="mb-3">
                {{ activeClients }}/{{ totalClients }}
                <!-- <span class="fs-12 fw-medium text-danger">
                  <i class="fa-solid fa-caret-down me-1"></i>
                  -11.2%
                </span> -->
              </h3>
              <router-link to="/crm/clients" class="link-default">
                View All
              </router-link>
            </div>
          </div>
        </div>

        <!-- Total Tasks -->
        <div v-if="showTasksWidget" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-pink mb-2">
                <i class="ti ti-checklist fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">
                Total No of Tasks ({{ props.year }})
              </h6>
              <h3 class="mb-3">
                {{ completedTasks }}/{{ totalTasks }}
                <!-- <span class="fs-12 fw-medium text-success">
                  <i class="fa-solid fa-caret-down me-1"></i>
                  +11.2%
                </span> -->
              </h3>
              <router-link to="/projects/tasks" class="link-default">
                View All
              </router-link>
            </div>
          </div>
        </div>

        <!-- Earnings (year-aware "this month vs last month" comparison) -->
        <div v-if="showFinanceWidgets" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-purple mb-2">
                <i class="ti ti-moneybag fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">
                Earnings ({{ props.year }})
              </h6>
              <h3 class="mb-3">
                {{ formatMoney(earnings) }}
                <span
                  class="fs-12 fw-medium"
                  :class="earningsPct >= 0 ? 'text-success' : 'text-danger'"
                >
                  <i
                    class="fa-solid"
                    :class="earningsPct >= 0 ? 'fa-caret-up' : 'fa-caret-down'"
                  ></i>
                  {{ Math.abs(earningsPct).toFixed(1) }}%
                </span>
              </h3>
            </div>
          </div>
        </div>

        <!-- Profit: week only when current year, otherwise selected-year profit -->
        <div v-if="showFinanceWidgets" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-danger mb-2">
                <i class="ti ti-browser fs-16"></i>
              </span>

              <h6 class="fs-13 fw-medium text-default mb-1">
                {{
                  isCurrentYear ? "Profit This Week" : `Profit (${props.year})`
                }}
              </h6>

              <h3 class="mb-3">
                {{
                  formatMoney(
                    isCurrentYear ? profitThisWeek : profitSelectedYear
                  )
                }}

                <!-- Show % compare only for weekly profit -->
                <span
                  v-if="isCurrentYear"
                  class="fs-12 fw-medium"
                  :class="profitPct >= 0 ? 'text-success' : 'text-danger'"
                >
                  <i
                    class="fa-solid"
                    :class="profitPct >= 0 ? 'fa-caret-up' : 'fa-caret-down'"
                  ></i>
                  {{ Math.abs(profitPct).toFixed(1) }}%
                </span>
              </h3>
            </div>
          </div>
        </div>

        <!-- New Hire -->
        <div v-if="showEmployeeWidget" class="col-md-3 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <span class="avatar rounded-circle bg-dark mb-2">
                <i class="ti ti-user-star fs-16"></i>
              </span>
              <h6 class="fs-13 fw-medium text-default mb-1">
                New Hires ({{ props.year }})
              </h6>
              <h3 class="mb-3">
                {{ newHires }}/{{ totalEmployees }}
                <!-- <span class="fs-12 fw-medium text-danger">
                  <i class="fa-solid fa-caret-down me-1"></i>
                  -11.2%
                </span> -->
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Widget Info -->

    <!-- Employees By Department -->
    <!-- <div class="col-xxl-4 d-flex">
      <div class="card flex-fill">
        <div
          class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap"
        >
          <h5 class="mb-2">Employees By Department</h5>

          <div class="dropdown mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-white border btn-sm d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-calendar me-1"></i>
              {{ deptPeriodLabel }}
            </a>

            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a
                  class="dropdown-item rounded-1"
                  href="javascript:void(0);"
                  @click="deptPeriod = 'this_month'"
                >
                  This Month
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  href="javascript:void(0);"
                  @click="deptPeriod = 'this_week'"
                >
                  This Week
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  href="javascript:void(0);"
                  @click="deptPeriod = 'last_week'"
                >
                  Last Week
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="card-body">
          <div id="emp-department">
            <apexchart
              type="bar"
              height="220"
              :options="empDepartment.department"
              :series="empDepartment.series"
            />
          </div>

          <p class="fs-13">
            <i class="ti ti-circle-filled me-2 fs-8 text-primary"></i>
            Showing <span class="fw-bold">{{ deptPeriodLabel }}</span> hires by
            department
          </p>
        </div>
      </div>
    </div> -->
    <!-- /Employees By Department -->
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";

import { useAdminLeaveStore } from "@/stores/adminLeaveStore";
import { useProjectStore } from "@/stores/projectStore";
import { useCrmClientStore } from "@/stores/crmClientStore";
import { useTaskStore } from "@/stores/taskStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import { useAdminAttendanceStatsStore } from "@/stores/adminAttendanceStatsStore";
import { useAdminDashboardStore } from "@/stores/adminDashboardStore";
import { useAuthStore } from "@/stores/authStore";
import { useAccessStore } from "@/stores/accessStore";
import { useCompanyStore } from "@/stores/companyStore";
import { MODULE_KEYS } from "@/config/modules-registry";
import { resolveAvatarUrl } from "@/utils/imageHelpers";
import { storeToRefs } from "pinia";

const props = defineProps({
  year: { type: Number, required: true },
});

// Stores
const adminLeaveStore = useAdminLeaveStore();
const projectStore = useProjectStore();
const clientStore = useCrmClientStore();
const taskStore = useTaskStore();
const employeeStore = useEmployeeStore();
const adminAttendanceStatsStore = useAdminAttendanceStatsStore();
const adminDashboardStore = useAdminDashboardStore();
const authStore = useAuthStore();
const accessStore = useAccessStore();

onMounted(async () => {
  await accessStore.ensureAccess();
  if (accessStore.hasModule(MODULE_KEYS.HRM_ATTENDANCE)) {
    adminLeaveStore.fetchStats({
      date_from: "",
      date_to: "",
      status: "",
      q: "",
      type_id: "",
    });
  }
});

const showAttendanceWidget = computed(() =>
  accessStore.hasModule(MODULE_KEYS.HRM_ATTENDANCE),
);
const showProjectsWidget = computed(() =>
  accessStore.hasModule(MODULE_KEYS.PROJECTS),
);
const showClientsWidget = computed(() =>
  accessStore.hasModule(MODULE_KEYS.CRM_CLIENTS),
);
const showTasksWidget = computed(
  () =>
    accessStore.hasModule(MODULE_KEYS.TASKS) ||
    accessStore.hasModule(MODULE_KEYS.TASK_BOARD),
);
const showFinanceWidgets = computed(
  () =>
    accessStore.hasModule(MODULE_KEYS.FA_SALES) ||
    accessStore.hasModule(MODULE_KEYS.FA_ACCOUNTING),
);
const showEmployeeWidget = computed(() =>
  accessStore.hasModule(MODULE_KEYS.HRM_EMPLOYEE),
);

const {
  earnings,
  profitSelectedYear,
  profitThisWeek,
  profitPrevWeek,
  earningsThisMonth,
  earningsPrevMonth,
} = storeToRefs(adminDashboardStore);

const companyStore = useCompanyStore();
const { companies, activeCompanyId } = storeToRefs(companyStore);

const activeCompany = computed(() =>
  companies.value.find((c) => c.id === activeCompanyId.value)
);

const companyCurrencySymbol = computed(() => {
  const c = activeCompany.value;
  return c?.currency_symbol || c?.currency_code || "KES";
});
/* ----------------------------
  User name
---------------------------- */
const userName = computed(() => {
  const user = authStore.currentUser;
  const first = user?.first_name || user?.employee?.first_name || "";
  const last = user?.last_name || user?.employee?.last_name || "";
  const full = `${first} ${last}`.trim();
  return full || user?.name || "User";
});

const welcomeAvatarUrl = computed(() => {
  const user = authStore.currentUser;
  const path =
    user?.employee?.avatar_url ||
    user?.avatar_url ||
    user?.logo_url ||
    null;
  return resolveAvatarUrl(path);
});

/* ----------------------------
  Year helpers
---------------------------- */
function pctChange(curr, prev) {
  const a = Number(curr || 0);
  const b = Number(prev || 0);
  if (b === 0) return a === 0 ? 0 : 100;
  return ((a - b) / Math.abs(b)) * 100;
}

const currentYear = new Date().getFullYear();
const isCurrentYear = computed(() => props.year === currentYear);

/* ----------------------------
  Comparisons
---------------------------- */
const profitPct = computed(() =>
  pctChange(profitThisWeek.value, profitPrevWeek.value)
);
const earningsPct = computed(() =>
  pctChange(earningsThisMonth.value, earningsPrevMonth.value)
);

/* ----------------------------
  Leaves hero stats
---------------------------- */
const pendingApprovalsCount = computed(
  () => adminLeaveStore.stats.total_pending || 0
);

const totalLeaveRequestsCount = computed(() => {
  const fromStats = adminLeaveStore.stats?.total_requests;
  if (typeof fromStats === "number") return fromStats;
  return 0;
});

function parseDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function isInCalendarYear(value, year) {
  const d = parseDate(value);
  return !!d && d.getFullYear() === Number(year);
}

function pickHireDate(e) {
  return (
    e.company_doj ||
    e.company_doj_formatted ||
    e.company_doj_label ||
    e.created_at ||
    null
  );
}

function pickEndDate(e) {
  return (
    e.employment_end_date ||
    e.date_left ||
    e.leaving_date ||
    e.terminated_at ||
    null
  );
}

function employedDuringYear(e, year) {
  const yearStart = new Date(year, 0, 1);
  const yearEnd = new Date(year, 11, 31, 23, 59, 59, 999);
  const hire = parseDate(pickHireDate(e));
  if (!hire) {
    // No DOJ: only count for current year so empty DOJ does not inflate past years
    return Number(year) === currentYear;
  }
  if (hire > yearEnd) return false;
  const end = parseDate(pickEndDate(e));
  if (end && end < yearStart) return false;
  return true;
}

/* ----------------------------
  Attendance Overview
---------------------------- */
const attendanceLabel = computed(() => {
  const stats = adminAttendanceStatsStore.stats;
  const present = stats.present || 0;
  const total = stats.total_employees || 0;
  if (!total) return "0/0";
  return `${present}/${total}`;
});

const attendancePresentPct = computed(() => {
  const pct = adminAttendanceStatsStore.stats.present_pct || 0;
  return pct.toFixed(1);
});

/* ----------------------------
  Projects (created in selected year)
---------------------------- */
const projectsInYear = computed(() =>
  (projectStore.items || []).filter((p) =>
    isInCalendarYear(p.created_at || p.start_date || p.created_pretty, props.year)
  )
);

const totalProjects = computed(() => projectsInYear.value.length);

const activeProjects = computed(
  () =>
    projectsInYear.value.filter(
      (p) => String(p.status || "").toLowerCase() === "active"
    ).length
);

/* ----------------------------
  Clients (created in selected year)
---------------------------- */
const clientsInYear = computed(() =>
  (clientStore.clients || []).filter((c) =>
    isInCalendarYear(c.created_at || c.created_pretty, props.year)
  )
);

const totalClients = computed(() => clientsInYear.value.length);

const activeClients = computed(
  () =>
    clientsInYear.value.filter(
      (c) => String(c.status || "").toLowerCase() === "active"
    ).length
);

/* ----------------------------
  Tasks (created in selected year)
---------------------------- */
const tasksInYear = computed(() =>
  (taskStore.items || []).filter((t) =>
    isInCalendarYear(t.created_at || t.created_pretty || t.start_date, props.year)
  )
);

const totalTasks = computed(() => tasksInYear.value.length);

const completedTasks = computed(
  () =>
    tasksInYear.value.filter((t) =>
      ["completed", "done", "closed"].includes(
        String(t.status || "").toLowerCase()
      )
    ).length
);

/* ----------------------------
  Employees / new hires for selected year
---------------------------- */
const employeesInYear = computed(() =>
  (employeeStore.employees || []).filter((e) => employedDuringYear(e, props.year))
);

const totalEmployees = computed(() => employeesInYear.value.length);

const newHires = computed(() =>
  employeesInYear.value.filter((e) =>
    isInCalendarYear(pickHireDate(e), props.year)
  ).length
);

/* ----------------------------
  Helpers
---------------------------- */
function formatMoney(amount) {
  const currency = companyCurrencySymbol.value;
  const n = Number(amount || 0);
  return `${currency} ${n.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  })}`;
}

</script>
